import { css } from "styled-components";
import { darken, lighten } from "polished";

export default css`
    .button {
        background-color: ${p => p.theme.c.active};
        box-sizing: border-box;
        border-radius: 8px;
        padding: 8px;
        font-size: 18px;
        cursor: pointer;
        color: ${p => p.theme.c.snowOnActive};
        border: 2px solid transparent;
        outline: none;
        font-weight: 600;
        margin-bottom: 16px;
        position: relative;
        user-select: none;

        :hover {
            background-color: ${p => p.theme.c.boost};
        }

        :focus {
            border: 2px solid ${p => p.theme.c.dark};
        }

        :disabled, &.disabled {
            background-color: ${p => p.theme.c.pale};
            cursor: default;
        }

        &.button--light {
            background-color: ${p => p.theme.mode === "dark" ? "transparent" : p.theme.c.white};
            box-sizing: border-box;
            color: ${p => p.theme.mode === "dark" ? p.theme.c.black : p.theme.c.active};
            border: 2px solid ${p => p.theme.mode === "dark" ? p.theme.c.black : p.theme.c.active};

            &:hover {
                background-color: ${p => p.theme.mode === "dark" ? "transparent" : p.theme.c.light};
            }

            &:disabled {
                background-color: ${p => p.theme.c.disabled};
                color: ${p => p.theme.c.snow};
                border-color: ${p => p.theme.c.disabled};
            }

            :focus {
                border: 2px solid ${p => p.theme.mode === "dark" ? p.theme.c.light : p.theme.c.dark};
            }
        }
        &.button--thin {
            &,
            &:focus {
                border-width: 1px;
            }
        }
        &.button--play {
            background-color: ${p => p.theme.c.play};
            box-sizing: border-box;
            color: ${p => p.theme.c.whiteOnActive};
            border: 2px solid ${p => darken(0.05, p.theme.c.play)};
            padding-bottom: 2px;
            &:hover {
                background-color: ${p => lighten(0.1, p.theme.c.play)};
            }

            &:focus {
                border: 2px solid ${p => darken(0.14, p.theme.c.play)};
            }
            &:disabled {
                background-color: ${p => lighten(0.3, p.theme.c.play)};
                border-color: transparent;
                color: ${p => p.theme.c.snow};
            }
        }

        &.button--info {
            background-color: ${p => p.theme.c.info};
            box-sizing: border-box;
            color: ${p => p.theme.c.whiteOnActive};
            border: 2px solid ${p => darken(0.05, p.theme.c.info)};
            padding-bottom: 2px;
            &:hover {
                background-color: ${p => lighten(0.1, p.theme.c.info)};
            }

            &:focus {
                border: 2px solid ${p => darken(0.14, p.theme.c.info)};
            }
            &:disabled {
                background-color: ${p => lighten(0.3, p.theme.c.info)};
                border-color: transparent;
                color: ${p => p.theme.c.snow};
            }
        }

        &.button--check {
            background-color: ${p => p.theme.c.check};
            box-sizing: border-box;
            color: ${p => p.theme.c.whiteOnActive};
            border: 2px solid ${p => darken(0.05, p.theme.c.check)};
            padding-bottom: 2px;

            &:hover {
                background-color: ${p => lighten(0.1, p.theme.c.check)};
            }

            &:focus {
                border: 2px solid ${p => darken(0.14, p.theme.c.check)};
            }
            &:disabled {
                background-color: ${p => lighten(0.18, p.theme.c.check)};
                border-color: transparent;
                color: ${p => p.theme.c.snow};
            }
        }

        &.button--full-width {
            width: 100%;
        }

        &.button--pretty {
            color: ${p => p.theme.c.active} !important;
            background-color: ${p => p.theme.c.whiteOnActive};
            border-color: ${p => p.theme.c.light} !important;

            :hover {
                background-color: ${p => p.theme.c.light};
                color: ${p => p.theme.c.boost} !important;
            }

            :focus {
                border-color: ${p => p.theme.c.dark} !important;
            }
        }
    }

    .button-facebook {
        position: absolute;
        top: 4px;
        left: 4px;
        .i-facebook {
            color: ${p => p.theme.c.snowOnActive};
            font-size: 32px;
        }

        &.button-facebook--dark {
            .i-facebook {
                color: ${p => p.theme.c.facebook};
            }
        }
    }

    .button-google {
        position: absolute;
        top: 4px;
        left: 6px;
        .i-google {
            color: ${p => p.theme.c.snowOnActive};
            font-size: 32px;
        }

        &.button-google--dark {
            .i-google {
                color: ${p => p.theme.c.google};
            }
        }
    }

    .button--loading {
        cursor: progress !important;
    }

    .pulsate {
        animation: Pulsate 2s infinite;
    }

    &.button--with-margin-right {
        margin-right: 12px;
    }

    @keyframes Pulsate {
        0% {
            transform: scale(0.92, 0.92);
        }
        50% {
            transform: scale(1.12, 1.12);
        }
        100% {
            transform: scale(0.92, 0.92);
        }
    }
`;
